__turbopack_context__.v({
  "checkbox": "OptionFieldInput-module-scss-module__FTjUvW__checkbox",
  "checked": "OptionFieldInput-module-scss-module__FTjUvW__checked",
  "disabled": "OptionFieldInput-module-scss-module__FTjUvW__disabled",
  "empty": "OptionFieldInput-module-scss-module__FTjUvW__empty",
  "error": "OptionFieldInput-module-scss-module__FTjUvW__error",
  "green": "OptionFieldInput-module-scss-module__FTjUvW__green",
  "greenRadio": "OptionFieldInput-module-scss-module__FTjUvW__greenRadio",
  "heart": "OptionFieldInput-module-scss-module__FTjUvW__heart",
  "indeterminate": "OptionFieldInput-module-scss-module__FTjUvW__indeterminate",
  "radio": "OptionFieldInput-module-scss-module__FTjUvW__radio",
  "root": "OptionFieldInput-module-scss-module__FTjUvW__root",
  "switch": "OptionFieldInput-module-scss-module__FTjUvW__switch",
  "thumb": "OptionFieldInput-module-scss-module__FTjUvW__thumb",
});
